export const LOCATION_UPLOAD_MESSAGES = {
  FILE_REQUIRED: 'Error: File must be uploaded to continue',
  ROW_LIMIT_EXCEEDED:
    "You've uploaded a very high number of zip codes, exceeding the project limit of 25,000. For better efficiency and a smoother experience with Suppliers, consider targeting broader areas like regions, states, or counties instead. Reach out to our support team at support@purespectrum.com if you'd like help refining your approach!",
  INVALID_LOCATION_CODE_FILE:
    'The file has been imported but it contains invalid ZIP/Post code(s).\nIf you use the “DOWNLOAD CURRENT FILE” option, we will indicate which Postcodes are ‘valid’ and which are ‘invalid’.',
  INVALID_FSA_CODE_FILE:
    'The file has been imported but it contains invalid FSA code(s). \nIf you use the "DOWNLOAD CURRENT FILE" option, we will indicate which FSA codes are `valid` and which are `invalid`.',
  MODIFIED_SUFFIX:
    ' Some Lines Were Modified Because They Were Only 4 or 3 Digits Long',
  UPLOAD_FAILED: 'Failed to upload location codes',
} as const;

export const locationUploadSuccessMessage = ({
  correctCodeCount,
  totalCodeCount,
  duplicateCodeCount,
  modifiedCodeCount,
  qualificationName,
}: {
  correctCodeCount: number;
  totalCodeCount: number;
  duplicateCodeCount: number;
  modifiedCodeCount: number;
  qualificationName: string;
}): string => {
  const modified = modifiedCodeCount
    ? LOCATION_UPLOAD_MESSAGES.MODIFIED_SUFFIX
    : '';
  const duplicated = duplicateCodeCount
    ? `. ${duplicateCodeCount} duplicate ${qualificationName} skipped.`
    : '';

  return `${correctCodeCount} out of ${totalCodeCount} ${qualificationName} successfully uploaded${modified}${duplicated}`;
};

export const locationUploadRejectedMessage = (
  incorrectCodeCount: number,
  incorrectCodes: readonly string[],
): string =>
  `File uploaded but contains ${incorrectCodeCount} invalid ZIP/Post code(s) that were rejected: ${incorrectCodes.join(', ')}`;

export const locationCodesClearedMessage = (
  qualificationName: string,
): string => `${qualificationName} cleared successfully`;
